import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import { Fragment, useContext } from 'react';
import { SecondaryButton } from '~/components/common/Button';
import GlobalContext from '~/context/vdp/GlobalContext';
import Chevron from '~/icons/Chevron';
import { getStandoutTierCategories, getVehicleDetails } from '~/selectors';
import useSelector from '~/store/useSelector';
import CategoryCard from './CategoryCard';
import HighlightCard from './HightlightCard';
import InstalledPackagesCard from './InstalledPackagesCard';
import { SectionHeader } from '../../styles';
import useGetFeatureTourHighlights from '../useGetFeatureTourHighlights';

export const Heading = createComponent('h3', {
  className: `tl-header-m m:tl-header-xl`
});

export const Section = createComponent('section', {
  className: `flex w-full flex-col justify-start gap-2xl`
});

export default function FeaturesAndHighlights() {
  const { openHotspot } = useContext(GlobalContext);
  const featureTourHighlights = useGetFeatureTourHighlights();
  const standoutCategories = useSelector(getStandoutTierCategories);
  const { installedPackages = [], parentModel } =
    useSelector(getVehicleDetails);

  const showInstalledPackages = installedPackages.length > 0;
  const showDivider = featureTourHighlights.length < 4;

  return (
    <div className="px-2xl">
      <SectionHeader>
        {`why you\u2019ll love this`}
        <p>{parentModel}</p>
      </SectionHeader>
      <div
        className={cx(
          'mx-auto mt-4xl flex max-w-[1144px] flex-col items-center justify-start gap-4xl',
          {
            'm:divide-y m:divide-grey-2': showDivider
          }
        )}
      >
        <Section>
          <Heading>Highlights</Heading>
          <div className="flex w-full flex-col gap-xl m:grid m:auto-rows-[minmax(0,_1fr)] m:grid-cols-2 l:grid-cols-3">
            {featureTourHighlights.map(({ title, ...rest }) => (
              <HighlightCard key={title} title={title} {...rest} />
            ))}
          </div>
        </Section>

        <Section className={cx('mb-8', { 'm:pt-4xl': showDivider })}>
          <Heading>Key Features</Heading>

          <div className="flex flex-col justify-start">
            <div className="grid w-full grid-cols-1 gap-y-[42px] m:grid-cols-3 m:gap-x-xl m:gap-y-3xl">
              {standoutCategories.map((category, index) => (
                <Fragment key={category.name}>
                  <CategoryCard category={category} index={index} />
                </Fragment>
              ))}
              {showInstalledPackages && <InstalledPackagesCard />}
            </div>
          </div>

          <div className="group w-[250px] self-center m:self-start">
            <SecondaryButton
              className="mt-4xl w-full"
              data-analytics-id="Key Features - Details"
              onClick={() => openHotspot(0, false)}
            >
              view details
              <Chevron className="-:group-hover:stroke-white" />
            </SecondaryButton>
          </div>
        </Section>
      </div>
    </div>
  );
}
